<!--
 * @Description: 个别教育记录 列表页
 * @Author: ztw
 * @Date: 2023-03-01 15:13:39.344
 * @LastEditors: Xyyyyyy
 * @LastEditTime: 2023-11-28 17:43:53
-->
<template>
  <div>
    <el-dialog class="wp90 h800" v-model="openList" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Suitcase />
          </el-icon>
          <span class="header-title">个别教育记录</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="openList=false;homeCloseWindow('openReturn', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <div class="list-page pl0 pr0 pt0 pb0">
      <el-container>
        <el-header>
          <!-- 搜索区域 BEGIN -->
          <el-form class="search-box" :model="dataGrid.parms" @submit.enter.prevent>

            <el-form-item class="mr10">
              <el-select placeholder="学期" v-model="dataGrid.parms.xqid" clearable filterable @change="bindTable()">
                <el-option v-for="item in xqData" :key="item.id" :label="item.xqmc" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-form>
          <!-- 搜索区域 END -->
          <!-- 按钮区域 BEGIN -->
          <div class="button-box">
            <el-button type="primary" @click="openAdd=true"><span class="iconfont icon-chuangjian"></span>添加</el-button>
            <el-button type="warning" @click="remove()"><span class="iconfont icon-shanchu"></span>批量删除</el-button>
            <el-dropdown>
              <el-button type="info">
                <el-icon class="el-icon--left">
                  <DocumentCopy />
                </el-icon>导入/导出<el-icon class="el-icon--right"><arrow-down /></el-icon>
              </el-button>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item>
                    <el-upload :http-request="importInsert" :auto-upload="true" :show-file-list="false" accept=".xlsx, .xls">Excel导入数据</el-upload>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <el-upload :http-request="importUpdate" :auto-upload="true" :show-file-list="false" accept=".xlsx, .xls">Excel更新数据</el-upload>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <el-upload :http-request="importCover" :auto-upload="true" :show-file-list="false" accept=".xlsx, .xls">Excel覆盖数据</el-upload>
                  </el-dropdown-item>
                  <el-dropdown-item @click="exportData" divided>导出到Excel</el-dropdown-item>
                  <el-dropdown-item @click="download">下载Excel模板</el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </div>
          <!-- 按钮区域 END -->
        </el-header>
        <el-main>
          <el-table :data="dataGrid.data" :default-sort="dataGrid.orderBy" v-loading="dataGrid.loading" @sort-change="dataGrid.sortChange" @selection-change="dataGrid.selectionChange" height="100%" border stripe>
            <!-- 冻结列-Left BEGIN -->
            <el-table-column type="selection" width="55" align="center" />
            <el-table-column label="序号" type="index" width="80" fixed align="center" />
            <!-- 冻结列-Left END -->
            <el-table-column label="学期" prop="xqmc" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
            <el-table-column label="学生" prop="xm" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
            <el-table-column label="日期" prop="rq" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
            <el-table-column label="教育情况" prop="jyqk" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
            <el-table-column label="效果" prop="xg" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
            <!-- 冻结列-Right BEGIN -->
            <el-table-column label="操作" width="180" fixed="right" align="center">
              <template #default="scope">
                <el-button link type="success" @click="openDetail=true; row=scope.row">详情</el-button>
                <el-button link type="primary" @click="openEdit=true; row=scope.row">修改</el-button>
                <el-button link type="warning" @click="dataGrid.multipleSelection=[scope.row.id]; remove()">删除</el-button>
              </template>
            </el-table-column>
            <!-- 冻结列-Right END -->
          </el-table>
        </el-main>
        <el-footer>
          <pagination :pagination="dataGrid.pagination" @ReturnData="bindTable" />
        </el-footer>
      </el-container>
      </div>
    </el-dialog>
  </div>
  <add v-if="openAdd" v-model:openAdd="openAdd" @ReturnData="bindTable" />
  <edit v-if="openEdit" v-model:openEdit="openEdit" :row="row" @ReturnData="bindTable" />
  <detail v-if="openDetail" v-model:openDetail="openDetail" :row="row" />
</template>

<script setup>
import { ref, watch, defineProps, defineEmits } from 'vue'
import {
  loadList,
  submitDataGridAction,
  submitExcel,
  exportExcel,
  downloadTemplate,
  homeCloseWindow,
  loadSelect
} from '@/api/common.js'
import pagination from '@/components/pagination.vue'
import add from './add.vue'
import edit from './edit.vue'
import detail from './detail.vue'

const props = defineProps({ open: { type: String, required: true }, row: { type: Object, required: false } })
const emits = defineEmits(['openReturn', 'ReturnData'])

const xqData = ref()
const initXueQi = async () => {
  loadSelect({
    url: '/api/v2/pdp/xueqi/list',
    data: xqData,
    order: 'sx',
    sort: 'asc',
    loadSuccess: function (res) {
      res.data.forEach((element) => {
        if (element.sfdqxq === true) {
          dataGrid.value.parms.xqid = element.id
        }
      })
    }
  })
}

const dataGrid = ref({
  parms: {},
  data: [],
  pagination: {},
  loading: false,
  orderBy: { prop: 'id', order: 'ascending' },
  multipleSelection: [],
  sortChange: function (column) {
    dataGrid.value.orderBy.prop = column.prop
    dataGrid.value.orderBy.order = column.order
    bindTable()
  },
  selectionChange: function (selection) {
    dataGrid.value.multipleSelection = selection.map((item) => item.id)
  }
})
const bindTable = async (pageNo, pageSize) => {
  loadList({
    url: '/api/v2/xuesheng/banzhurengongzuogebiejiaoyujilu/pagelist',
    pageNo: pageNo || 1,
    pageSize: pageSize || 100,
    dataGrid: dataGrid.value,
    loadSuccess: function () {
      dataGrid.value.multipleSelection = []
    }
  })
}

// 弹窗
const row = ref()
const openAdd = ref(false)
const openEdit = ref(false)
const openDetail = ref(false)
const openList = ref(false)

// 删除
const remove = async () => {
  submitDataGridAction({
    url: '/api/v2/xuesheng/banzhurengongzuogebiejiaoyujilu',
    dataGrid: dataGrid.value,
    confirmTitle: '确定要删除吗?',
    method: 'delete',
    callback: function () {
      bindTable()
    }
  })
}

watch(
  () => props.open,
  () => {
    if (props.open === 'gebiejiaoyujilu') {
      openList.value = true
      bindTable()
      initXueQi()
    } else {
      openList.value = false
    }
  },
  { deep: true, immediate: true }
)
// Excel导入数据
const importInsert = async (file) => {
  submitExcel({
    url: '/api/v2/xuesheng/banzhurengongzuogebiejiaoyujilu/importInsert',
    file: file,
    callback: function () {
      bindTable()
    }
  })
}
// Excel更新数据
const importUpdate = async (file) => {
  submitExcel({
    url: '/api/v2/xuesheng/banzhurengongzuogebiejiaoyujilu/importUpdate',
    file: file,
    callback: function () {
      bindTable()
    }
  })
}
// Excel覆盖数据
const importCover = async (file) => {
  submitExcel({
    url: '/api/v2/xuesheng/banzhurengongzuogebiejiaoyujilu/importCover',
    file: file,
    callback: function () {
      bindTable()
    }
  })
}

// Excel导出
const exportData = async () => {
  exportExcel(
    '/api/v2/xuesheng/banzhurengongzuogebiejiaoyujilu/export',
    dataGrid.value
  )
}

// 模板下载
const download = async () => {
  downloadTemplate('/api/v2/xuesheng/banzhurengongzuogebiejiaoyujilu/download')
}
</script>
